import { cn } from '@/lib/utils'

export const h2 = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) => (
  <h2
    className={cn(
      'font-heading mt-12 scroll-m-20 border-b pb-2 text-2xl font-normal tracking-tight first:mt-0',
      className
    )}
    {...props}
  />
)
